(function () {
    'use strict';
    angular.module('app').directive('selectioncommandrefreshextracteddata', selectioncommand_refreshextracteddata);
    selectioncommand_refreshextracteddata.$inject = ['$window'];
    function selectioncommand_refreshextracteddata($window) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                refreshExtractedDataDialogShown: '=?'
            },
            controller: 'refreshextracteddata',
            templateUrl: 'app/selectioncommand/selectioncommand_refreshextracteddata.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();